<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Call to action:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="10"
            [type]="'content'"
            [blockData]="block.variables?.['YoutubeVideoCtaText'] ?? ''"
            (handleOnChange)="onChange($event, 'YoutubeVideoCtaText')"
            [placeholder]="ctaTextPlaceholder"
            variable="YoutubeVideoCtaText"
            [isPlainText]="true"
            [blockId]="block.blockId"
            [restrictContent]="true"
          ></app-block-text>
        </div>
      </div>
    </div>
  </div>
</main>
